<div id="skip_anchor" class="content wideWd">
    <div class="blind"><h2>대시보드</h2></div>
    <div class="dis_grid">
        <div class="grid_box_inner">
            <a href="" class="grid_box_title">통합 현황 요약</a>
            <div class="grid_box_cont">
                <div class="summary_main">
                    <div class="summary_main_item">
                        <em class="summary_title">지급합계</em>
                        <span class="summary_subscript">지난 달 ({{lastMonthCommission.fromDate | date:'MM.dd'}} - {{lastMonthCommission.toDate | date:'MM.dd'}})</span>
                        <strong class="summary_price">&#8361; {{lastMonthCommission.commissionPrice | number}}</strong>
                    </div>
                    <div class="summary_main_item">
                        <em class="summary_title">평균 지급액</em>
                        <span class="summary_subscript">최근 6개월 ({{avgCommission.fromDate | date:'MM.dd'}} - {{avgCommission.toDate | date:'MM.dd'}})</span>
                        <strong class="summary_price">&#8361; {{avgCommission.commissionPrice | number}}</strong>
                    </div>
                </div>

                <div class="summary_box">
                    <div class="summary_box_item">
                        <em class="summary_title">총 구매건수</em>
                        <span class="summary_data">{{monthStats != null ? monthStats.buyEventCount : 0| number}}</span>
                    </div>
                    <div class="summary_box_item">
                        <em class="summary_title">총 구매금액</em>
                        <span class="summary_data">{{monthStats != null ? monthStats.totalPayment : 0 | number}}</span>
                    </div>
                    <div class="summary_box_item">
                        <em class="summary_title">전환율</em>
                        <span class="summary_data">{{monthStats != null ? ((monthStats.buyEventCount - monthStats.cancelEventCount)/monthStats.clickEventCount) : 0 | percent : '0.2'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid_box_inner">
            <strong class="grid_box_title">버디 현황 요약 <span class="grid_box_title_sub">이번달 매출순</span></strong>
            <div class="grid_box_cont table-row">
                <table class="table">
                    <tr>
                        <th>BuddyId</th>
                        <th>이름</th>
                        <th>결제금액</th>
                    </tr>
                    <tr *ngFor="let item of monthPaymentRanking">
                        <td>{{item.userId}}</td>
                        <td>{{item.userName | nameMasking}}</td>
                        <td>{{item.totalPayment | number}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="grid_box_inner">
            <a routerLink="/user/list" class="grid_box_title">승인 대기 회원</a>
            <div class="grid_box_cont">
                <strong class="counting_act">{{userWaitingCount | number}} <span class="col-gray">/ {{userConfirmCount | number}}</span></strong>
            </div>
        </div>
        <div class="grid_box_inner">
            <a routerLink="/voc/QNA/list" class="grid_box_title">미답변 문의</a>
            <div class="grid_box_cont">
                <strong class="counting_act">{{qnaWaitingCount | number}}</strong>
            </div>
        </div>
        <div class="grid_box_inner">
            <strong class="grid_box_title">베스트 상품 <span class="grid_box_title_sub">(10.01 - 10.31)</span></strong>
            <div class="grid_box_cont">
                <ol class="grid_box_list">
                    <li class="list_item" *ngFor="let item of bestProductByPrice;let idx = index">
                        <span class="list_item_order">{{idx + 1}}</span>
                        <div class="list_item_product dis_flex">
                            <div class="img_area"><img src="https://oasisprodproduct.edge.naverncp.com/{{item.productId}}/thumb/300" onerror="this.src='/assets/images/web/img/img_onerrer.jpg'"></div>
                            <div class="info_area">
                                <strong class="info_area_title">{{item.title}}</strong>
                            </div>
                        </div>
                        <span class="info_area_price">{{item.eventCount | number}}구매</span>
                        &nbsp;/&nbsp;
                        <span class="list_item_count">{{item.totalPrice | number}}원</span>
                    </li>
                </ol>
            </div>
        </div>
        <div class="grid_box_inner">
            <strong class="grid_box_title">베스트 링크 <span class="grid_box_title_sub">(10.01 - 10.31)</span></strong>
            <div class="grid_box_cont">
                <ol class="grid_box_list">
                    <li class="list_item" *ngFor="let item of bestProductByUrl;let idx = index">
                        <span class="list_item_order">{{idx + 1}}</span>
                        <div class="list_item_product dis_flex">
                            <div class="img_area"><img src="{{item.filePath}}" onerror="this.src='/assets/images/web/img/img_onerrer.jpg'"></div>
                            <div class="info_area">
                                <strong class="info_area_title">{{item.title}}</strong>
                            </div>
                        </div>
                        <span class="list_item_count">{{item.eventCount | number}}건</span>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>
